var CONFUSEDWEBSITE = CONFUSEDWEBSITE || {},
    CSSCONSTANTS = CSSCONSTANTS || {};

(function (factory) {
    if (typeof define === 'function' && define.amd) {
        define(function (require) {
            factory(require('jquery'));
        });
    } else {
        factory(window.jQuery);
    }
})(function ($) {

    CONFUSEDWEBSITE.setupHeaderActions = function () {

        var $myAccountDropdown = $('.global-header__actions .btn--dropdown');

        $myAccountDropdown.on('click', function(e) {
            e.preventDefault();
            var $this = $(this),
                windowWidth = $(window).width();

            if($this.hasClass('btn--dropdown--closed')) {
                $this.removeClass('btn--dropdown--closed');
                $this.addClass('btn--dropdown--open');
                if (windowWidth > 800) {
                    $('.global-header__secondary').css('margin-top', '-2px');
                }
            }
            else {
                $this.removeClass('btn--dropdown--open');
                $this.addClass('btn--dropdown--closed');
                $('.global-header__secondary').css('margin-top', '0');
            }
            $this.nextAll('.nav-dropdown').slideToggle('fast');
        });

	    enquire.register(CSSCONSTANTS.nonMobileHeaderMinWidthMQ, {
	        match: function () {

	            CONFUSEDWEBSITE.moveHeaderActions('nonMobile');

	        },
	        unmatch: function () {

	            CONFUSEDWEBSITE.moveHeaderActions('mobile');

	        }
	    }, true);
	};

	CONFUSEDWEBSITE.moveHeaderActions = function (screenSize) {
	    var $headerActions = $('.' + CSSCONSTANTS.globalHeaderActionsClass),
			$globalHeaderMasthead = $('.' + CSSCONSTANTS.globalHeaderMastheadClass),
			$globalHeaderSecondary = $('.' + CSSCONSTANTS.globalHeaderSecondaryClass + ' .' + CSSCONSTANTS.scaffoldClass + '.' + CSSCONSTANTS.columnClass);

		if (screenSize === 'nonMobile') {	
			$headerActions.appendTo($globalHeaderMasthead);
		}

		else if (screenSize === 'mobile') {
			$headerActions.appendTo($globalHeaderSecondary);
		}
	};

});